// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"978a725f","703":"dc72c41b","787":"2e30b042"}[chunkId] + ".chunk.js";
};